import { Store as PullStateStore, registerInDevtools } from 'pullstate';
import type { ChatConfig, ChatConfigWindow } from 'src';
import { getDefaultLabels, SubstitutableLabels } from '../utils/labels';
import { CONFIG_DEFAULTS } from '../constants';
import { shouldStartOpen } from '../utils/url';
import { FeatureFlags } from './feature-flags';

declare let window: ChatConfigWindow;

const windowWidth = window.innerWidth;

const shouldOpen = shouldStartOpen();
export const widgetVisibleKey = 'remark-isWidgetVisible';
export const activatorVisibleKey = 'remark-isActivatorVisible';

if (shouldOpen) {
  localStorage.setItem(activatorVisibleKey, 'hidden');
  // TODO, delete after 1/27/22, replace getItem instances
  localStorage.setItem('isActivatorVisible', 'hidden');
}

const startOpen =
  shouldOpen || (localStorage.getItem('isActivatorVisible') === 'hidden' && windowWidth > 479);

export const Store = new PullStateStore<StoreState>({
  config: CONFIG_DEFAULTS,
  skippedEmail: false,
  activatorVisible: !startOpen,
  widgetVisible: localStorage.getItem(widgetVisibleKey) !== 'hidden',
  muted: Boolean(localStorage.getItem('mutedChat')),
  unseenMessages: localStorage.getItem('unseenRemarkMessages')
    ? Number(localStorage.getItem('unseenRemarkMessages'))
    : 0,
  lastSeenMessageIndex: localStorage.getItem('lastSeenMessageIndex')
    ? Number(localStorage.getItem('lastSeenMessageIndex'))
    : 0,
  labels: getDefaultLabels(),
  ogLinkInfo: {},
  featureFlags: {},
  expertMatchedMessage: {},
  AITransferExpertJoined: {},
  submittedEmail: false,
  forcefullyShowFindingExpert: false
});

type StoreState = {
  activatorVisible: boolean;
  widgetVisible: boolean;
  config: ChatConfig;
  skippedEmail: boolean;
  muted: boolean;
  unseenMessages: number;
  ogLinkInfo: {
    [x in string]: {
      title: string;
      image: string;
      link: string;
      price?: number;
      currency?: string;
      video?: string;
    };
  };
  lastSeenMessageIndex: number;
  labels: SubstitutableLabels;
  featureFlags: FeatureFlags;
  expertMatchedMessage: Record<string, string>;
  AITransferExpertJoined: Record<string, boolean>;
  submittedEmail: boolean;
  forcefullyShowFindingExpert: boolean;
};

registerInDevtools({ Store });
